import { Info } from '@mui/icons-material';
import { Box, LinearProgress, styled, Grid, Tooltip, Avatar } from '@mui/material';
import { WsColorsNew, WsTypoColors, WsTypoVariants, WsTypography } from 'wisestep-base';

import AI_Image from '../../../../images/AI.svg';

const StyledLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 8,
  borderRadius: 4,
  backgroundColor: theme.palette.grey[200],
  '& .MuiLinearProgress-bar': {
    borderRadius: 4,
    transition: 'all 0.3s ease-in-out',
  },
}));

const InfoIcon = styled(Info)(({ theme }) => ({
  color: theme.palette.grey[500],
  fontSize: 18,
  cursor: 'pointer',
  '&:hover': { color: theme.palette.primary.main },
}));

const getProgressColor = (value: number) => {
  if (value <= 50) return WsColorsNew.danger_600;
  if (value <= 70) return WsColorsNew.warning_500;
  if (value <= 100) return WsColorsNew.success_500;
  return WsColorsNew.danger_600;
};

interface IAIInfoSectionProps {
  progress: number;
  title?: string;
  subtitle?: string;
}

const AIInfoSection = ({
  progress,
  title = 'JD & Skills Quality',
  subtitle,
}: IAIInfoSectionProps) => {
  const progressColor = getProgressColor(progress);

  return (
    <Grid container alignItems="center" spacing={2}>
      <Grid item>
        <Avatar src={AI_Image} variant="square" />
      </Grid>
      <Grid item xs={3}>
        <Box>
          <Box display="flex" alignItems="center" gap={0.5}>
            <WsTypography variant={WsTypoVariants.SUB_TITLE}>{title}</WsTypography>
            <Tooltip
              title={
                <>
                  <WsTypography variant={WsTypoVariants.BODY2}>
                    Length: At least 250 words
                  </WsTypography>
                  <WsTypography variant={WsTypoVariants.BODY2}>
                    Skills: At least 10 skills
                  </WsTypography>
                </>
              }
              arrow
            >
              <InfoIcon />
            </Tooltip>
          </Box>
          {subtitle && subtitle.trim() !== '' && (
            <WsTypography variant={WsTypoVariants.BODY2} color={WsTypoColors.SECONDARY}>
              {subtitle}
            </WsTypography>
          )}
        </Box>
      </Grid>
      <Grid item xs={6}>
        <Box display="flex" alignItems="center" gap={2}>
          <StyledLinearProgress
            variant="determinate"
            value={progress}
            sx={{
              flex: 1,
              '& .MuiLinearProgress-bar': { backgroundColor: progressColor },
            }}
          />
          <WsTypography variant={WsTypoVariants.BODY2}>{progress}%</WsTypography>
        </Box>
      </Grid>
    </Grid>
  );
};

export default AIInfoSection;
